import { COMPANY_URL } from "../../constants/apiUrls";
import { apiSlice } from "../apiSlice";

export const adminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    supportTicket: builder.mutation({
      query: ({ data, token }) => ({
        url: `${COMPANY_URL}/support/`,
        method: "POST",
        body: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
});

export const { useSupportTicketMutation } = adminApiSlice;
